import { createContext } from 'react';

const initialContext = {};
export default createContext(initialContext);
